import React, { lazy, Suspense } from "react";

import LoadingPage from "Dashboard/Components/LoadingPage";
import { Provider } from "react-redux";
import { useRouteMatch, Switch, Route, Redirect } from "react-router-dom";
import { BasicLoading } from "ZeroRuby";

import PartnerProvider from "Common/PartnerProvider";
import { useSiteConfig } from "Common/Redux/siteConfig";
import ScrollToTop from "Common/ScrollToTop";
import { ThemeProvider } from "Theme/Context";

import { useGetSurveyQuery } from "./api";
import Chrome from "./components/Chrome";
import { getUrlFromLargeGroupSurvey } from "./onLoadNavigation";
import { createStore } from "./redux";

const DonePage = lazy(() => import("./pages/DonePage" /* webpackChunkName: "LargeGroup_DonePage" */));
const LargeGroupQuoteRequestPage = lazy(() => import("./pages/LargeGroupQuoteRequestPage" /* webpackChunkName: "LargeGroup_QuoteRequestPage" */));

const AppPages = () => {
  const { data: largeGroupSurvey, isLoading: isLoadingLargeGroupSurvey, error: largeGroupSurveyError } = useGetSurveyQuery();
  const { isLoading: isLoadingSiteConfig } = useSiteConfig();

  const isLoading = isLoadingLargeGroupSurvey || isLoadingSiteConfig || largeGroupSurveyError;

  return (
    <ScrollToTop>
      <PartnerProvider>
        <Chrome title="Large Group Insurance">{isLoading ? <BasicLoading /> : <Routes />}</Chrome>
      </PartnerProvider>
    </ScrollToTop>
  );
};

const Routes = () => {
  const { data: largeGroupSurvey } = useGetSurveyQuery();
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Suspense fallback={<LoadingPage />}>
        <Route exact path={`${path}`} children={<Redirect to={`${getUrlFromLargeGroupSurvey(largeGroupSurvey)}`} />} />

        <Route path={`${path}/request-quote`} children={<LargeGroupQuoteRequestPage />} />
        <Route path={`${path}/done`} children={<DonePage />} />
      </Suspense>
    </Switch>
  );
};

class App extends React.Component {
  constructor() {
    super();
    this.store = createStore();
  }

  render() {
    return (
      <ThemeProvider cobalt>
        <Provider store={this.store}>
          <AppPages />
        </Provider>
      </ThemeProvider>
    );
  }
}

export default App;
